@if (!loadingPage()) {
  <div class="page">
    <div class="header">
      <h1 class="header-title">
        <mat-icon>settings</mat-icon>
        <span>Instellingen</span>
      </h1>
    </div>
    <div class="content">
      <form [formGroup]="organisationForm">
        <mat-tab-group class="settings" mat-align-tabs="left">
          <mat-tab label="Organisatie">
            <mat-card class="settings-card">
              <div class="content-wrapper">
                <mat-form-field>
                  <mat-label>Organisatienaam</mat-label>
                  <input formControlName="name" type="text" autocomplete="off" matInput (keydown.enter)="save()" />
                </mat-form-field>
                <div class="form-field-group">
                  <mat-form-field>
                    <mat-label>Privacyvoorwaarden link</mat-label>
                    <input
                      formControlName="privacyLink"
                      type="text"
                      autocomplete="off"
                      matInput
                      (keydown.enter)="save()"
                    />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Maximum aantal voertuigen</mat-label>
                    <input
                      formControlName="maxActiveVehicles"
                      matInput
                      type="number"
                      autocomplete="off"
                      (keydown.enter)="save()"
                    />
                  </mat-form-field>
                </div>
                <div class="form-field-group">
                  <mat-form-field>
                    <mat-label>Dagdelen starttijd</mat-label>
                    <mat-select formControlName="startHour">
                      @for (hour of hours; track hour) {
                        <mat-option [value]="hour">{{ hour }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Dagdelen eindtijd</mat-label>
                    <mat-select formControlName="endHour">
                      @for (hour of hours; track hour) {
                        <mat-option [value]="hour">{{ hour }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <mat-form-field>
                  <mat-label>ORS API Key</mat-label>
                  <input formControlName="orsApiKey" type="text" autocomplete="off" matInput (keydown.enter)="save()" />
                </mat-form-field>
                <h3 class="sub-title">Standaard e-mailaddressen</h3>
                <!-- <mat-form-field>
                  <mat-label>Standaard CC e-mailadressen</mat-label>
                  <mat-chip-grid #chipGridCC aria-label="CC email addresses">
                    @for (email of organisationForm.controls.emailNotificationsCCAddress.value; track email) {
                      <mat-chip-row (removed)="removeEmail(email, 'emailNotificationsCCAddress')">
                        {{ email }}
                        <button matChipRemove [attr.aria-label]="'remove ' + email">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                    <input
                      placeholder="Nieuw e-mailadres..."
                      [matChipInputFor]="chipGridCC"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="addEmail($event, 'emailNotificationsCCAddress')"
                    />
                  </mat-chip-grid>
                </mat-form-field> -->
                <mat-form-field>
                  <mat-label>Standaard BCC e-mailadressen</mat-label>
                  <mat-chip-grid #chipGridBCC aria-label="BCC email addresses">
                    @for (email of organisationForm.controls.emailNotificationsBCCAddress.value; track email) {
                      <mat-chip-row (removed)="removeEmail(email, 'emailNotificationsBCCAddress')">
                        {{ email }}
                        <button matChipRemove [attr.aria-label]="'remove ' + email">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                    <input
                      placeholder="Nieuw e-mailadres..."
                      [matChipInputFor]="chipGridBCC"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="addEmail($event, 'emailNotificationsBCCAddress')"
                    />
                  </mat-chip-grid>
                </mat-form-field>
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="askPin">
                    Om pincode vragen bij credits toevoegen/verminderen
                  </mat-slide-toggle>
                </div>
                <p class="warning">Let op! Het niet gebruiken van een pincode is op eigen risico.</p>
                @if (organisationForm.controls.askPin.value) {
                  <div class="form-field-group">
                    <mat-form-field>
                      <mat-label>Pincode voor credits opboeken</mat-label>
                      <input
                        formControlName="pinAddCredits"
                        type="text"
                        pattern="[0-9]*"
                        autocomplete="off"
                        #pin
                        matInput
                        minlength="4"
                        maxlength="4"
                        (keydown.enter)="save()"
                      />
                      @if (organisationForm.controls.pinAddCredits.hasError('minlength')) {
                        <mat-error>Pin moet 4 tekens zijn.</mat-error>
                      }
                      @if (organisationForm.controls.pinSubtractCredits.hasError('pattern')) {
                        <mat-error>De pin mag enkel cijfers bevatten.</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Pincode voor credits afboeken</mat-label>
                      <input
                        formControlName="pinSubtractCredits"
                        type="text"
                        pattern="[0-9]*"
                        autocomplete="off"
                        #pin
                        matInput
                        minlength="4"
                        maxlength="4"
                        (keydown.enter)="save()"
                      />
                      @if (organisationForm.controls.pinSubtractCredits.hasError('minlength')) {
                        <mat-error>Pin moet 4 tekens zijn.</mat-error>
                      }
                      @if (organisationForm.controls.pinSubtractCredits.hasError('pattern')) {
                        <mat-error>De pin mag enkel cijfers bevatten.</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (usesDriverPlanning) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="usesPlannerPlanning">
                      Planners kunnen net als chauffeurs ingeroosterd worden
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="Ritten" class="ride-tab">
            <mat-card class="settings-card">
              <div class="content-wrapper">
                <div class="form-field-group">
                  <mat-form-field>
                    <mat-label>Standaard ritduur (minuten)</mat-label>
                    <mat-select formControlName="customRideDuration">
                      @for (minute of travelMinutes; track minute) {
                        <mat-option [value]="minute">
                          {{ minute.toString().length < 2 ? '0' + minute : minute }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Tijdsblokken (minuten)</mat-label>
                    <mat-select formControlName="customSegment">
                      @for (segment of segmentMinutes; track segment) {
                        <mat-option [value]="segment">
                          {{ segment }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="form-field-group multiple">
                  <mat-form-field>
                    <mat-label>Standaard instaptijd (minuten)</mat-label>
                    <input formControlName="vehicleEntryDuration" matInput type="text" autocomplete="off" />
                    @if (organisationForm.controls.vehicleEntryDuration.hasError('max')) {
                      <mat-error>De instaptijd mag niet meer dan 15 minuten zijn.</mat-error>
                    } @else if (organisationForm.controls.vehicleEntryDuration.hasError('numberInput')) {
                      <mat-error>Vul een geldige waarde in.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Standaard uitstaptijd (minuten)</mat-label>
                    <input formControlName="vehicleExitDuration" matInput type="text" autocomplete="off" />
                    @if (organisationForm.controls.vehicleExitDuration.hasError('max')) {
                      <mat-error>De uitstaptijd mag niet meer dan 15 minuten zijn.</mat-error>
                    } @else if (organisationForm.controls.vehicleExitDuration.hasError('numberInput')) {
                      <mat-error>Vul een geldige waarde in.</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Maximale reistijd passagier (minuten)</mat-label>
                    <input formControlName="maxPassengerRideMinutes" matInput type="text" autocomplete="off" />
                    @if (organisationForm.controls.maxPassengerRideMinutes.hasError('numberInput')) {
                      <mat-error>Vul een geldige waarde in.</mat-error>
                    }
                  </mat-form-field>
                </div>
                @if (dataStore.paidFunctionalities?.usesAutomaticPlanning) {
                  <mat-form-field>
                    <mat-label>Startlocatie voertuigen</mat-label>
                    <input
                      #toInput
                      formControlName="defaultStartLocationInput"
                      placeholder="mijn straat 1, mijn dorp"
                      type="text"
                      matInput
                      [matAutocomplete]="toAuto"
                      (blur)="onDefaultStartLocationBlur()"
                    />
                    <mat-autocomplete
                      autoActiveFirstOption
                      #toAuto="matAutocomplete"
                      (optionSelected)="onSuggestionSelected($event)"
                    >
                      @for (option of defaultStartPrediction(); track option.address) {
                        <mat-option [value]="option">
                          {{ option.address }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (organisationForm.controls.defaultStartLocation.hasError('invalidLocation')) {
                      <mat-error>Selecteer een geldige locatie uit de suggesties.</mat-error>
                    }
                  </mat-form-field>

                  <div class="form-field-group">
                    <mat-form-field>
                      <mat-label>Standaard ophaalbuffer (minuten)</mat-label>
                      <input formControlName="bufferPickup" matInput type="number" autocomplete="off" />
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Standaard afzetbuffer (minuten)</mat-label>
                      <input formControlName="bufferDropoff" matInput type="number" autocomplete="off" />
                    </mat-form-field>
                  </div>
                }
                <div class="toggle-sections">
                  <div class="toggle-section">
                    <h3 class="sub-title">Plannen</h3>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="activateSignalColor">
                        Mogelijkheid om ritten als bijzonder te markeren.
                      </mat-slide-toggle>
                    </div>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="characteristicsStatus">Kenmerken gebruiken.</mat-slide-toggle>
                    </div>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="pCommentsToggle">
                        Opmerkingen voor planner bij passagiers in ritten.
                      </mat-slide-toggle>
                    </div>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="dCommentsToggle">
                        Opmerkingen voor chauffeur bij passagiers in ritten.
                      </mat-slide-toggle>
                    </div>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="showRideProduct">Ritprijs weergeven.</mat-slide-toggle>
                    </div>
                  </div>
                  <div class="toggle-section">
                    <h3 class="sub-title">Meldingen</h3>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="doubleBookingActivated">
                        Dubbele boeking melding uitzetten.
                      </mat-slide-toggle>
                    </div>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="noDeleteReason">
                        Geen reden voor verwijderde ritten nodig.
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div class="toggle-section">
                    <h3 class="sub-title">Chauffeurs-app</h3>
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="askKilometers">Kilometerstand vragen.</mat-slide-toggle>
                    </div>
                  </div>
                </div>
                <button
                  mat-flat-button
                  type="button"
                  (click)="exportRides()"
                  class="export-rides"
                  [class.spinner]="exportingRides()"
                  [disabled]="exportingRides()"
                >
                  <mat-icon>file_download</mat-icon>
                  <span> Exporteer alle uitgevoerde ritten </span>
                </button>
                <button
                  mat-flat-button
                  type="button"
                  class="export-rides"
                  (click)="openImportExport()"
                  [class.spinner]="transfering()"
                  [disabled]="transfering()"
                >
                  <mat-icon>import_export</mat-icon>
                  <span>Ritten importeren/exporteren</span>
                </button>
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="Medewerkers">
            <mat-card class="settings-card employees-card">
              <div class="content-wrapper">
                <h3 class="sub-title">Chauffeurs</h3>
                @if (usesDriverPlanning) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="driversModifyAvailability">
                      Mag hun beschikbaarheid zelf opgeven en aanpassen.
                    </mat-slide-toggle>
                  </div>
                }
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="driversShowParticipantPhone">
                    Mag het telefoonnummer van passagiers in de mobiele app zien.
                  </mat-slide-toggle>
                </div>
                @if (usesDriverPlanning) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="ignoreDriverStatus">
                      Negeer planstatus chauffeur.
                    </mat-slide-toggle>
                  </div>
                }
                @if (usesDriverRemarksInApp) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="driversAddRemarkInApp">
                      Kan een opmerking toevoegen in de mobiele app.
                    </mat-slide-toggle>
                  </div>
                }
                @if (!organisationForm.controls.ignoreDriverStatus.value && usesDriverPlanning) {
                  <div class="form-field-group daypart-time-driver">
                    <p class="driver-time-label">
                      Kies een tijdstip waarop chauffeurs een melding krijgen als een rit verandert.
                    </p>
                    <div class="driver-time">
                      <mat-form-field class="mat-form-field-no-subscript">
                        <mat-label>Uren</mat-label>
                        <mat-select formControlName="alertHour">
                          @for (hour of hours; track hour) {
                            <mat-option [value]="hour">{{ hour }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-no-subscript">
                        <mat-label>Minuten</mat-label>
                        <mat-select formControlName="alertMinute">
                          @for (minute of minutes; track minute) {
                            <mat-option [value]="minute">
                              {{ minute.toString().length < 2 ? '0' + minute : minute }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                }
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="emailNotificationsDriversDayPart">
                    E-mailnotificaties versturen.
                  </mat-slide-toggle>
                </div>

                <h3 class="sub-title">Planners</h3>
                @if (usesDriverPlanning) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="plannersModifyAvailability">
                      Mag hun beschikbaarheid zelf opgeven en aanpassen.
                    </mat-slide-toggle>
                  </div>
                }
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="emailNotificationsPlanners">
                    E-mailnotificaties versturen.
                  </mat-slide-toggle>
                </div>

                <h3 class="sub-title">Bijrijders</h3>
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="coDriverEnabled">Bijrijdersrol gebruiken.</mat-slide-toggle>
                </div>
                @if (organisationForm.controls.emailNotificationsCoDriversDayPart.enabled) {
                  @if (usesDriverPlanning) {
                    <div class="toggle-switch">
                      <mat-slide-toggle formControlName="coDriversModifyAvailability">
                        Mag hun beschikbaarheid zelf opgeven en aanpassen.
                      </mat-slide-toggle>
                    </div>
                  }
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="emailNotificationsCoDriversDayPart">
                      E-mailnotificaties versturen.
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="Passagiers">
            <mat-card class="settings-card">
              <div class="content-wrapper">
                <div class="toggle-switch">
                  <mat-slide-toggle formControlName="askBirthDay">
                    Passagiers bij registratie om geboortedatum vragen.
                  </mat-slide-toggle>
                </div>
                <div class="toggle-switch-last">
                  <mat-slide-toggle formControlName="askGender">
                    Passagiers bij registratie om geslacht vragen.
                  </mat-slide-toggle>
                </div>
                @if (usesUserNotificationSystem) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="emailNotificationsParticipants">
                      E-mailnotificaties versturen.
                    </mat-slide-toggle>
                  </div>
                }
                @if (organisationForm.controls.emailNotificationsParticipants.value) {
                  <div class="checkbox-rows secondary-color">
                    <mat-checkbox formControlName="emailNotificationsParticipantsRideConfirmed"
                      >Ritbevestiging</mat-checkbox
                    >
                    <mat-checkbox formControlName="emailNotificationsParticipantsRideChanged"
                      >Ritwijziging</mat-checkbox
                    >
                    <mat-checkbox formControlName="emailNotificationsParticipantsRideDeleted"
                      >Rit verwijderd</mat-checkbox
                    >
                    <mat-checkbox formControlName="emailNotificationsParticipantsRideReminder"
                      >Voor aanvang van rit</mat-checkbox
                    >
                    @if (organisationForm.controls.emailNotificationsParticipantsRideReminder.value) {
                      <mat-form-field class="mat-form-field-no-subscript">
                        <mat-label>Minuten</mat-label>
                        <mat-select formControlName="emailNotificationsParticipantsRideReminderAmount">
                          @for (minute of reminderMinutes; track minute) {
                            <mat-option [value]="minute">
                              {{ minute.toString().length < 2 ? '0' + minute : minute }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                }
                @if (usesUserNotificationSystem) {
                  <div class="toggle-switch">
                    <mat-slide-toggle formControlName="smsNotificationsParticipants">
                      SMS-notificaties versturen.
                    </mat-slide-toggle>
                  </div>
                }
                @if (organisationForm.controls.smsNotificationsParticipants.value) {
                  <div class="checkbox-rows secondary-color">
                    <mat-checkbox formControlName="smsNotificationsParticipantsRideConfirmed"
                      >Ritbevestiging</mat-checkbox
                    >
                    <mat-checkbox formControlName="smsNotificationsParticipantsRideChanged">Ritwijziging</mat-checkbox>
                    <mat-checkbox formControlName="smsNotificationsParticipantsRideDeleted"
                      >Rit verwijderd</mat-checkbox
                    >
                    <mat-checkbox formControlName="smsNotificationsParticipantsRideReminder"
                      >Voor aanvang van rit</mat-checkbox
                    >
                    @if (organisationForm.controls.smsNotificationsParticipantsRideReminder.value) {
                      <mat-form-field class="mat-form-field-no-subscript">
                        <mat-label>Minuten</mat-label>
                        <mat-select formControlName="smsNotificationsParticipantsRideReminderAmount">
                          @for (minute of reminderMinutes; track minute) {
                            <mat-option [value]="minute">
                              {{ minute.toString().length < 2 ? '0' + minute : minute }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                }
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="Vormgeving">
            <mat-card class="settings-card">
              <div class="content-wrapper">
                <div class="form-field-group" [class.multiple]="organisationForm.value.activateSignalColor">
                  <mat-form-field class="color-picker-field">
                    <mat-label>Primaire kleur</mat-label>
                    <input
                      matInput
                      placeholder="#EFEFEF"
                      readonly="true"
                      formControlName="primaryColor"
                      [value]="cpValue1"
                      #ignoredInput
                      [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                      [(cpToggle)]="cpToggle1"
                      [(colorPicker)]="cpValue1"
                      [cpAlphaChannel]="'disabled'"
                      [cpOKButton]="true"
                      [cpPosition]="'bottom'"
                      [cpCancelButton]="true"
                      [cpCancelButtonClass]="'mat-stroked-button'"
                      [cpOKButtonClass]="'mat-stroked-button'"
                      [cpCancelButtonText]="'Annuleren'"
                    />
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Kleurkiezer primaire kleur openen"
                      #ignoredButton
                      type="button"
                      (click)="cpToggle1 = !cpToggle1"
                    >
                      <mat-icon
                        [ngStyle]="{
                          color: cpValue1,
                        }"
                        >circle
                      </mat-icon>
                    </button>
                  </mat-form-field>
                  <mat-form-field class="color-picker-field">
                    <mat-label>Accent kleur</mat-label>
                    <input
                      matInput
                      placeholder="#EFEFEF"
                      readonly="true"
                      formControlName="accentColor"
                      [value]="cpValue2"
                      #ignoredInput
                      [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                      [(cpToggle)]="cpToggle2"
                      [(colorPicker)]="cpValue2"
                      [cpAlphaChannel]="'disabled'"
                      [cpOKButton]="true"
                      [cpPosition]="'bottom'"
                      [cpCancelButton]="true"
                      [cpCancelButtonClass]="'mat-stroked-button'"
                      [cpOKButtonClass]="'mat-stroked-button'"
                      [cpCancelButtonText]="'Annuleren'"
                    />
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Kleurkiezer accent kleur openen"
                      #ignoredButton
                      type="button"
                      (click)="cpToggle2 = !cpToggle2"
                    >
                      <mat-icon
                        [ngStyle]="{
                          color: cpValue2,
                        }"
                        >circle
                      </mat-icon>
                    </button>
                  </mat-form-field>
                  @if (organisationForm.value.activateSignalColor) {
                    <mat-form-field class="color-picker-field">
                      <mat-label>Signaalkleur bijzondere rit</mat-label>
                      <input
                        matInput
                        placeholder="#EFEFEF"
                        readonly="true"
                        formControlName="signalColor"
                        [value]="cpValue3"
                        #ignoredInput
                        [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                        [(cpToggle)]="cpToggle3"
                        [(colorPicker)]="cpValue3"
                        [cpAlphaChannel]="'disabled'"
                        [cpOKButton]="true"
                        [cpPosition]="'bottom'"
                        [cpCancelButton]="true"
                        [cpCancelButtonClass]="'mat-stroked-button'"
                        [cpOKButtonClass]="'mat-stroked-button'"
                        [cpCancelButtonText]="'Annuleren'"
                      />
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Kleurkiezer signaalkleur bijzondere rit openen"
                        #ignoredButton
                        type="button"
                        (click)="cpToggle3 = !cpToggle3"
                      >
                        <mat-icon
                          [ngStyle]="{
                            color: cpValue3,
                          }"
                          >circle
                        </mat-icon>
                      </button>
                    </mat-form-field>
                  }
                </div>
                <h3>Afbeeldingen</h3>
                <div class="form-field-group upload-row">
                  <div class="upload-wrapper">
                    <h4>Favicon</h4>
                    <div
                      class="upload-preview"
                      role="button"
                      [attr.tabindex]="isSuperUser ? 0 : -1"
                      [attr.aria-disabled]="!isSuperUser"
                      aria-label="Favicon uploaden"
                      matTooltip="Klik om een afbeelding te uploaden"
                      matTooltipClass="wide-tooltip"
                      (click)="isSuperUser ? openFileInput('faviconInput') : null"
                      (keydown.enter)="isSuperUser ? openFileInput('faviconInput') : null"
                      (keydown.space)="$event.preventDefault(); isSuperUser ? openFileInput('faviconInput') : null"
                      [ngClass]="{ pointer: isSuperUser }"
                      [ngStyle]="{
                        'background-image': organisationForm.controls.favicon.value?.name
                          ? 'url(' + previewImage('favicon') + ')'
                          : 'url(https://placehold.co/150x150?text=Upload)',
                      }"
                    ></div>
                    @if (isSuperUser) {
                      <div class="upload-buttons">
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Favicon downloaden"
                          matTooltip="Afbeelding downloaden"
                          (click)="downloadFile('favicon')"
                          [disabled]="!organisationForm.controls.favicon.value?.name"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Favicon verwijderen"
                          matTooltip="Afbeelding verwijderen"
                          (click)="deleteFile('favicon')"
                          [disabled]="!organisationForm.controls.favicon.value?.name"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                    <input
                      hidden
                      type="file"
                      id="faviconInput"
                      (change)="uploadedFile($event, 'favicon')"
                      accept="image/x-icon"
                    />
                  </div>
                  <div class="upload-wrapper">
                    <h4>Banner</h4>
                    <div
                      class="upload-preview"
                      role="button"
                      [attr.tabindex]="isSuperUser ? 0 : -1"
                      [attr.aria-disabled]="!isSuperUser"
                      aria-label="Banner uploaden"
                      matTooltip="Klik om een afbeelding te uploaden"
                      matTooltipClass="wide-tooltip"
                      (click)="isSuperUser ? openFileInput('bannerInput') : null"
                      (keydown.enter)="isSuperUser ? openFileInput('bannerInput') : null"
                      (keydown.space)="$event.preventDefault(); isSuperUser ? openFileInput('bannerInput') : null"
                      [ngClass]="{ pointer: isSuperUser }"
                      [ngStyle]="{
                        'background-image': organisationForm.controls.banner.value?.name
                          ? 'url(' + previewImage('banner') + ')'
                          : 'url(https://placehold.co/150x150?text=Upload)',
                      }"
                    ></div>
                    @if (isSuperUser) {
                      <div class="upload-buttons">
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Banner downloaden"
                          matTooltip="Afbeelding downloaden"
                          (click)="downloadFile('banner')"
                          [disabled]="!organisationForm.controls.banner.value?.name"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Banner verwijderen"
                          matTooltip="Afbeelding verwijderen"
                          (click)="deleteFile('banner')"
                          [disabled]="!organisationForm.controls.banner.value?.name"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                    <input
                      hidden
                      type="file"
                      id="bannerInput"
                      (change)="uploadedFile($event, 'banner')"
                      accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                    />
                  </div>
                  <div class="upload-wrapper">
                    <h4>Logo</h4>
                    <div
                      class="upload-preview"
                      role="button"
                      [attr.tabindex]="isSuperUser ? 0 : -1"
                      [attr.aria-disabled]="!isSuperUser"
                      aria-label="Logo uploaden"
                      matTooltip="Klik om een afbeelding te uploaden"
                      matTooltipClass="wide-tooltip"
                      (click)="isSuperUser ? openFileInput('logoInput') : null"
                      (keydown.enter)="isSuperUser ? openFileInput('logoInput') : null"
                      (keydown.space)="$event.preventDefault(); isSuperUser ? openFileInput('logoInput') : null"
                      [ngClass]="{ pointer: isSuperUser }"
                      [ngStyle]="{
                        'background-image': organisationForm.controls.logo.value?.name
                          ? 'url(' + previewImage('logo') + ')'
                          : 'url(https://placehold.co/150x150?text=Upload)',
                      }"
                    ></div>
                    @if (isSuperUser) {
                      <div class="upload-buttons">
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Logo downloaden"
                          matTooltip="Afbeelding downloaden"
                          (click)="downloadFile('logo')"
                          [disabled]="!organisationForm.controls.logo.value?.name"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Logo verwijderen"
                          matTooltip="Afbeelding verwijderen"
                          (click)="deleteFile('logo')"
                          [disabled]="!organisationForm.controls.logo.value?.name"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                    <input
                      hidden
                      type="file"
                      id="logoInput"
                      (change)="uploadedFile($event, 'logo')"
                      accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                    />
                  </div>
                  <div class="upload-wrapper">
                    <h4>Inlogpagina</h4>
                    <div
                      class="upload-preview"
                      role="button"
                      [attr.tabindex]="isSuperUser ? 0 : -1"
                      [attr.aria-disabled]="!isSuperUser"
                      aria-label="Inlogafbeelding uploaden"
                      matTooltip="Klik om een afbeelding te uploaden"
                      matTooltipClass="wide-tooltip"
                      (click)="isSuperUser ? openFileInput('loginImageInput') : null"
                      (keydown.enter)="isSuperUser ? openFileInput('loginImageInput') : null"
                      (keydown.space)="$event.preventDefault(); isSuperUser ? openFileInput('loginImageInput') : null"
                      [ngClass]="{ pointer: isSuperUser }"
                      [ngStyle]="{
                        'background-image': organisationForm.controls.loginImage.value?.name
                          ? 'url(' + previewImage('loginImage') + ')'
                          : 'url(https://placehold.co/150x150?text=Upload)',
                      }"
                    ></div>
                    @if (isSuperUser) {
                      <div class="upload-buttons">
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Inlogafbeelding downloaden"
                          matTooltip="Afbeelding downloaden"
                          (click)="downloadFile('loginImage')"
                          [disabled]="!organisationForm.controls.loginImage.value?.name"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                        <button
                          class="upload-option"
                          mat-icon-button
                          aria-label="Inlogafbeelding verwijderen"
                          matTooltip="Afbeelding verwijderen"
                          (click)="deleteFile('loginImage')"
                          [disabled]="!organisationForm.controls.loginImage.value?.name"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                    <input
                      hidden
                      type="file"
                      id="loginImageInput"
                      (change)="uploadedFile($event, 'loginImage')"
                      accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                    />
                  </div>
                </div>
              </div>
            </mat-card>
          </mat-tab>
          <mat-tab label="Licentie">
            <mat-card class="settings-card">
              <div class="content-wrapper">
                <h3>Planning</h3>
                <div
                  class="toggle-switch"
                  matTooltip="Hier kunnen medewerkers hun beschikbaarheid opgeven. Planners kunnen daarnaast de beschikbaarheid van andere medewerkers inzien."
                >
                  <mat-slide-toggle formControlName="usesDriverPlanning">Roostersysteem</mat-slide-toggle>
                </div>
                <div
                  class="toggle-switch"
                  matTooltip="Schakelt het geavanceerde systeem in voor automatische optimalisatie van ritplanning."
                >
                  <mat-slide-toggle formControlName="usesAutomaticPlanning"
                    >Automatische planningssysteem</mat-slide-toggle
                  >
                </div>
                @if (isSuperUser) {
                  <div
                    class="toggle-switch"
                    matTooltip="Privévoertuigen zijn bij het plannen alleen beschikbaar voor hun vaste chauffeur en eventuele bijrijder."
                  >
                    <mat-slide-toggle formControlName="usesPrivateVehicles"
                      >Privé-voertuigen gebruiken</mat-slide-toggle
                    >
                  </div>
                }
                <div
                  class="toggle-switch-last"
                  matTooltip="Hiermee kunnen medewerkers via een AI-chatassistent vragen stellen over planningsdata."
                >
                  <mat-slide-toggle formControlName="usesAIChat">AI-chatassistent</mat-slide-toggle>
                </div>

                <h3>Medewerkers</h3>
                <div
                  class="toggle-switch"
                  matTooltip="Hiermee kunnen chauffeurs via de mobiele app opmerkingen en bijzonderheden over ritten toevoegen."
                >
                  <mat-slide-toggle formControlName="usesDriverRemarksInApp"
                    >Opmerkingen toevoegen voor chauffeurs in de app aanzetten</mat-slide-toggle
                  >
                </div>
                <div
                  class="toggle-switch"
                  matTooltip="Hiermee kun je de persoonsgegevens van medewerkers beheren, zoals hun adresgegevens."
                >
                  <mat-slide-toggle formControlName="usesEmployeePersonalDataManagement"
                    >Persoonsgegevens medewerkers beheren</mat-slide-toggle
                  >
                </div>
                <div
                  class="toggle-switch-last"
                  matTooltip="Hiermee kunnen medewerkers elkaar bekijken in de medewerkerslijst en elkaars profielfoto zien, als deze is ingesteld."
                >
                  <mat-slide-toggle formControlName="usesEmployeeListForStaff"
                    >Personeel mag bij medewerkerslijst</mat-slide-toggle
                  >
                </div>
                <h3>Passagiers</h3>
                <div
                  class="toggle-switch"
                  matTooltip="Hiermee kunnen automatische e-mail- en sms-herinneringen over geplande ritten naar passagiers worden verstuurd."
                >
                  <mat-slide-toggle formControlName="usesUserNotificationSystem"
                    >Passagiernotificaties inschakelen</mat-slide-toggle
                  >
                </div>
                <div
                  class="toggle-switch"
                  matTooltip="Hiermee kunnen betalingen via automatische incasso (SEPA) worden verwerkt."
                >
                  <mat-slide-toggle formControlName="usesSEPASystem">SEPA-betaalmethode</mat-slide-toggle>
                </div>
              </div>
            </mat-card>
          </mat-tab>
        </mat-tab-group>
      </form>
    </div>
    <input hidden type="file" id="import" accept=".json" #uploader (change)="uploadedFile($event, 'import')" />
    <button
      mat-fab
      extended
      [disabled]="!organisationForm.valid"
      class="save-button"
      [class.spinner]="saving()"
      (click)="save()"
    >
      <mat-icon>save</mat-icon>Opslaan
    </button>
  </div>
}
@if (loadingPage()) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
